import React from 'react';
import './Founders.css';

function Founders() {
  const founders = [
    {
      name: "Avinash",
      role: "Founder",
      linkedin: "https://www.linkedin.com/in/avinashdas-b-a-936671130/",
    },
    {
      name: "Yadukrishnan",
      role: "Co-Founder",
      linkedin: "https://www.linkedin.com/in/yadukrishnantp/",
    },
    {
      name: "Vinayak S.G.",
      role: "Co-Founder",
      linkedin: "https://www.linkedin.com/in/vinayak-sg-963825156/",
    },
  ];

  return (
    <section id="founders" className="founders-section">
      <div className="container">
        <h2 className="section-title">Built by Friends. Driven by Purpose.</h2>
        <div className="founders-intro">
          <p className="intro-text">
            HashFusion Innovations is run by three friends who bring together complementary
            strengths across technology, product, and business.
          </p>
          <p className="intro-text">
            What binds us is curiosity, trust, and a shared commitment to building things
            that genuinely help people live better lives.
          </p>
        </div>
        <div className="founders-grid">
          {founders.map((founder, index) => (
            <div key={index} className="founder-card">
              <div className="founder-image-placeholder">
                <div className="avatar-circle">
                  {founder.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <h3 className="founder-name">{founder.name}</h3>
              <p className="founder-role">{founder.role}</p>
              <a href={founder.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-link">
                <svg className="linkedin-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
                LinkedIn
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Founders;
